function Button(props){
    return(
        <button>{props.texte}</button>
    )
}

export default Button;